module.exports = __webpack_public_path__ + "static/scale-model-of-maple-school-natural-area-in-renton-washington-37bf5cc92970cb067f8375f6284c4d3d.png";